// @flow

import React from 'react';

import { Avatar } from '@zapier/common-components';

import { HeaderContext } from 'web-ssr/app/common/components/ContentHeader/HeaderProvider';

const AvatarContainer = () => {
  return (
    <HeaderContext.Consumer>
      {({ imageUrl, fullName, email }) => {
        const name = fullName ? fullName.trim() : email;

        return <Avatar name={name || ''} url={imageUrl} />;
      }}
    </HeaderContext.Consumer>
  );
};

export default AvatarContainer;
